export const releaseDropdownConfig:any = {
  "placeholderText":"Release Name"
 };

export const testScheduleColumns = [
  {
    key: "expand",
    showExpand: true,
    headerStyles: {
      color: "#ffffff",
      background: "#7593F2",
      width: "30px",
    },
  },
  {
    key: "planName",
    display_name: "Name",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
  {
    key: "caseName",
    display_name: "Test case Name",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
  {
    key: "version",
    display_name: "Version",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
  {
    key: "agent",
    display_name: "Execution Engine",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
  {
    key: "browser",
    display_name: "Browser",
    headerStyles: {
      background: "#7593F2",
      color: "#ffffff",
      padding: "4px 8px",
    },
  },
];